/*!
 * Module exports.
 */

'use strict';

exports.Collection = function() {
  throw new Error('Cannot create a collection from browser library');
};
exports.Connection = function() {
  throw new Error('Cannot create a connection from browser library');
};
